import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { liteClient } from 'algoliasearch/lite';
import { AlgoliaConfigProvider } from './AlgoliaConfigProvider.js';
import { AlgoliaServerState } from './AlgoliaServerState.js';
import { getAlgoliaServerState } from './get-algolia-server-state.js';
import { addFacetVisibility } from './utils/add-facet-visibility.js';
import { parseCommercialFacets } from './utils/parse-commercial-facets.js';

function getCommercialCategories(searchClient, indexName, locale, isMultilingualEnabled) {
    return _getCommercialCategories.apply(this, arguments);
}
function _getCommercialCategories() {
    _getCommercialCategories = swcHelpers.asyncToGenerator(function*(searchClient, indexName, locale, isMultilingualEnabled) {
        try {
            var ref;
            /**
     * Algolia SDK does not easily expose all the facets in the resultsState, so we have to
     * manually fetch all the facets and integrate them to the existing ones coming from next.config.
     * The alternative is to get from rawResults (https://github.com/algolia/instantsearch/issues/6202)
     * but since we need to have access to all facets before we SSR, we need to fetch all the facets here:
     */ const prefetchFacetsResult = yield searchClient.search({
                requests: [
                    {
                        indexName,
                        query: '',
                        facets: [
                            '*'
                        ]
                    }
                ]
            });
            var ref1;
            const rawFacets = (ref1 = (ref = prefetchFacetsResult.results[0]) === null || ref === void 0 ? void 0 : ref.facets) !== null && ref1 !== void 0 ? ref1 : {};
            const commercialFacets = parseCommercialFacets({
                rawFacets,
                locale,
                isMultilingualEnabled
            });
            return commercialFacets;
        } catch (error) {
            console.error('An error occurred while fetching algolia commercial categories:', error);
        }
        return [];
    });
    return _getCommercialCategories.apply(this, arguments);
}
const enrichAlgoliaConfig = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(props, router) {
        const { isEnabled , locale , presetQueryString , isMultilingualEnabled , options: { apiKey , appId , indexName  } ,  } = props;
        if (!isEnabled) {
            return props;
        }
        const searchClient = liteClient(appId, apiKey);
        const commercialFacets = yield getCommercialCategories(searchClient, indexName, locale, isMultilingualEnabled);
        const enrichedProps = swcHelpers.objectSpread({}, props, {
            searchClient,
            options: swcHelpers.objectSpread({}, props.options, {
                facets: addFacetVisibility([
                    ...props.options.facets,
                    ...commercialFacets
                ], locale, presetQueryString)
            })
        });
        const serverState = yield getAlgoliaServerState(/*#__PURE__*/ React.createElement(AlgoliaConfigProvider, swcHelpers.extends({}, enrichedProps, {
            router: router
        }), /*#__PURE__*/ React.createElement(AlgoliaServerState, null)));
        return swcHelpers.objectSpread({}, enrichedProps, {
            serverState
        });
    });
    return function enrichAlgoliaConfig(props, router) {
        return _ref.apply(this, arguments);
    };
}();

export { enrichAlgoliaConfig, getCommercialCategories };
//# sourceMappingURL=enrich-algolia-config.js.map
